const TYPE = {
  PDF: 'application/pdf',
  PDF_CL: 'pdf',
  RAR: 'rar',
  IMAGE: 'image/jpg',
  HEIC: 'heic',
  MP4: 'mp4',
  VIDEO: 'video/mp4',
  MOV: 'mov',
};

export default {
  TYPE,
};
